/**
 * SHX product cards — makes the image area open the product page.
 *
 * Shrine/Dawn cards stretch the title link over the card with a positioned
 * ::after; the SHX styles introduce positioned ancestors that shrink that layer
 * to the text area only. One delegated listener restores full-image clicks for
 * every SHX card — including cards rendered later (recommendations, quick view),
 * with no per-card wiring and no markup changes. Keyboard users are unaffected:
 * the title link remains the tab stop.
 */

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (event.target.closest('a, button, input, label, select, modal-opener, quick-add-modal')) return;
  const media = event.target.closest(
    '.card--shx_overlay .card__media, .card--shx_editorial .card__media, .card--shx_boutique .card__media'
  );
  if (!media) return;
  const link = media.closest('.card')?.querySelector('.card__heading a[href]');
  if (link) window.location.href = link.href;
});
